module.exports = __webpack_public_path__ + "img/minus-grey.2c6ca16b.svg";